import VBCWebSDK, { NOTIFICATION_SOUND, NOTIFICATION_ICON, DOWNLOAD_FILE_TYPES } from '@vonage/vbc-web-sdk';
import store from '@/store';

let vbcSdk;

export function init() {
  vbcSdk = new VBCWebSDK({ developmentMode: true });
}

// TODO Replace this with a proxy
/**
 * @return {VBCWebSDK}
 */
export default function () {
  return vbcSdk;
}
export function setMockSdk(mock) {
  vbcSdk = mock;
}

export function onHostEvent(eventId, cb, optional = false) {
  const isEventPermissionFound = store.state.permissions.events.findIndex((permission) => permission === eventId) >= 0;

  if (!isEventPermissionFound) {
    if (optional) {
      return;
    } else {
      throw Error(`No permission for event ${eventId}`);
    }
  }

  return vbcSdk.registerEvent(eventId, cb);
}

// We want to wrap 'sendCustomAction' as there might be actions that are not supported in all platforms and we need to handle exceptions
export function makeCustomAction(action, options) {
  return vbcSdk.sendCustomAction(action, options).catch((err) => console.error(`An error occurred for custom action execution: ${err}`));
}

// We want to wrap 'sendCustomEvent' as there might be actions that are not supported in all platforms and we need to handle exceptions
export function sendCustomEvent(event, payload) {
  return vbcSdk.sendCustomEvent(event, payload).catch((err) => console.error(`An error occurred for custom event: ${err}`));
}

export { NOTIFICATION_ICON, NOTIFICATION_SOUND, DOWNLOAD_FILE_TYPES };
